import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/lib/base/buttons/button';

/** Shown when the chat route is reached without an org in the URL. */
export function TeamRequiredState() {
  const navigate = useNavigate();
  const handleSelectOrganization = useCallback(
    () => navigate('/organizations'),
    [navigate]
  );

  return (
    <div className='min-h-dvh bg-bg-secondary flex items-center justify-center gradient-bg'>
      <div className='text-center'>
        <h1 className='text-2xl font-bold text-fg-primary mb-4'>
          Team required
        </h1>
        <p className='text-fg-tertiary mb-4'>
          This feature requires you to be in a team context.
        </p>
        <Button color='primary' onClick={handleSelectOrganization}>
          Select organization
        </Button>
      </div>
    </div>
  );
}
